export enum ContentOperations {
	UPDATE = 'UPDATE',
	ADD = 'ADD',
	REMOVE = 'REMOVE',
	MOVE = 'MOVE',
	REFRESH = 'REFRESH',
}
